const areaCity = {
  areaNo: 'Area Code',
  areaName: 'Area Name',
  cityNo: 'City Code',
  cityName: 'City Name',
  activeOffName: 'Is Active',
  msg: {}
};
export default areaCity



// WEBPACK FOOTER //
// ./src/page/md/areaCity/lang/areaCity.en.js